import {Component, forwardRef, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-input-on-off',
  templateUrl: './input-on-off.component.html',
  styleUrls: ['./input-on-off.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputOnOffComponent),
    multi: true
  }]
})
export class InputOnOffComponent implements OnInit, ControlValueAccessor{

  public inputModel: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  private onChangeFn: any = () => {
  };
  private onTouchedFn: any = () => {
  };


  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public writeValue(value: boolean): void {
    this.inputModel = value;
  }

  onCheckBoxClicked() {
    this.inputModel = !this.inputModel;
    this.onChangeFn(this.inputModel);
  }
}
